export const STARTER_PACK_EVENT_LIST_REQUEST = 'STARTER_PACK_EVENT_LIST_REQUEST';

export const STARTER_PACK_EVENT_LIST = 'STARTER_PACK_EVENT_LIST';

export const STARTER_PACK_EVENT_RESPONSE_MESSAGE = 'STARTER_PACK_EVENT_RESPONSE_MESSAGE';

export const STARTER_PACK_EVENT_CREATE_REQUEST = 'STARTER_PACK_EVENT_CREATE_REQUEST';

export const STARTER_PACK_EVENT_INFO_DETAILS_REQUEST = 'STARTER_PACK_EVENT_INFO_DETAILS_REQUEST';

export const STARTER_PACK_EVENT_INFO_DETAILS = 'STARTER_PACK_EVENT_INFO_DETAILS';

export const STARTER_PACK_EVENT_INFO_UPDATE_REQUEST = 'STARTER_PACK_EVENT_INFO_UPDATE_REQUEST';

export const STARTER_PACK_EVENT_INFO_DELETE_REQUEST = 'STARTER_PACK_EVENT_INFO_DELETE_REQUEST';

export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';

export const SET_STARTER_PACK_EVENT_PAGINATION = 'SET_STARTER_PACK_EVENT_PAGINATION';

export const STARTER_PACK_EVENT_PAGE_RESET = 'STARTER_PACK_EVENT_PAGE_RESET';

export const STARTER_PACK_EVENT_DEPOSIT_REQUEST = 'STARTER_PACK_EVENT_DEPOSIT_REQUEST';

export const STARTER_PACK_EVENT_ADD_BUDGET = 'STARTER_PACK_EVENT_ADD_BUDGET';
